import { Trophy } from "lucide-react";

/**
 * Badge shown on members who won the monthly blog leaderboard 3 months in a row.
 * Renders nothing when `active` is false.
 */
export default function ContributorBadge({ active, size = 14, className = "" }) {
  if (!active) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-gradient-to-r from-[#F5C543] to-[#E39F1B] text-white text-[10px] font-bold uppercase tracking-wider shadow-sm ${className}`}
      title="Juara papan peringkat 3 bulan berturut-turut"
      data-testid="contributor-badge"
    >
      <Trophy size={size - 2} /> Top Kontributor
    </span>
  );
}
